/**
 * Handles the setup of analytics events
 * @module embed/analytics
 */

import { injectAnalyticsScript, sendAnalytics, set } from '@/lib/analytics';
import { injectOptimiseScript } from '@/lib/optimisemedia_tracker';
import { delegate } from '@/lib/events';

const ATTR_EVENT_CATEGORY = 'data-analytics-event-category';
const ATTR_EVENT_LABEL = 'data-analytics-event-label';
const ATTR_EVENT = 'data-analytics-event';
const ATTR_PAGE_VIEW = 'data-analytics-page-view';

const SELECTOR = 'html.js-with-analytics';
const SELECTOR_EVENT = `[${ATTR_EVENT}]`;

const ACTION_ENTER_SLIDE = 'entered_slide';

export function sendSlideAnalytics(scope) {
  setPage(scope.getAttribute(ATTR_PAGE_VIEW));
  if (scope) {
    sendSlideEntranceEvent(
      scope.getAttribute(ATTR_EVENT_CATEGORY),
      scope.getAttribute(ATTR_EVENT_LABEL)
    );
    sendPageView();
  }
}

export function sendEvent(source, ...eventArgs) {
  const categoryHolder = source.closest(`[data-analytics-event-category]`);
  if (categoryHolder) {
    const category = categoryHolder.getAttribute(ATTR_EVENT_CATEGORY);
    if (category) {
      sendAnalytics('event', category, ...eventArgs);
    }
  }
}

export default function setupAnalytics() {
  if (document.querySelector(SELECTOR)) {
    injectAnalyticsScript();
    injectOptimiseScript();
    document.addEventListener(
      'click',
      delegate(SELECTOR_EVENT, (e, target) => {
        const event = JSON.parse(target.getAttribute(ATTR_EVENT));
        sendEvent(target, ...event);
      })
    );
  }
}

function sendSlideEntranceEvent(category, label) {
  if (category && label) {
    sendAnalytics('event', category, ACTION_ENTER_SLIDE, label);
  }
}

function sendPageView() {
  sendAnalytics('pageview');
}

function setPage(url) {
  set('page', url);
}



// WEBPACK FOOTER //
// ./app/webpack/javascripts/embed/analytics.js